import { StopInterface } from 'store/ducks/stops/types';

/*
 * Action Types
 */
export enum SectionsTypes {
  LIST_SECTIONS_REQUEST = '@sections/LIST_SECTIONS_REQUEST',
  LIST_SECTIONS_SUCCESS = '@sections/LIST_SECTIONS_SUCCESS',
  LIST_SECTIONS_FAILURE = '@sections/LIST_SECTIONS_FAILURE',

  GET_SECTION_REQUEST = '@sections/GET_SECTION_REQUEST',
  GET_SECTION_SUCCESS = '@sections/GET_SECTION_SUCCESS',
  GET_SECTION_FAILURE = '@sections/GET_SECTION_FAILURE',

  FILTER_SECTIONS_REQUEST = '@sections/FILTER_SECTIONS_REQUEST',
  FILTER_SECTIONS_SUCCESS = '@sections/FILTER_SECTIONS_SUCCESS',
  FILTER_SECTIONS_FAILURE = '@sections/FILTER_SECTIONS_FAILURE',

  CREATE_SECTION_REQUEST = '@sections/CREATE_SECTION_REQUEST',
  CREATE_SECTION_SUCCESS = '@sections/CREATE_SECTION_SUCCESS',
  CREATE_SECTION_FAILURE = '@sections/CREATE_SECTION_FAILURE',

  CREATE_SECTIONS_REQUEST = '@sections/CREATE_SECTIONS_REQUEST',
  CREATE_SECTIONS_SUCCESS = '@sections/CREATE_SECTIONS_SUCCESS',
  CREATE_SECTIONS_FAILURE = '@sections/CREATE_SECTIONS_FAILURE',

  UPDATE_SECTION_REQUEST = '@sections/UPDATE_SECTION_REQUEST',
  UPDATE_SECTION_SUCCESS = '@sections/UPDATE_SECTION_SUCCESS',
  UPDATE_SECTION_FAILURE = '@sections/UPDATE_SECTION_FAILURE',

  DELETE_SECTION_REQUEST = '@sections/DELETE_SECTION_REQUEST',
  DELETE_SECTION_SUCCESS = '@sections/DELETE_SECTION_SUCCESS',
  DELETE_SECTION_FAILURE = '@sections/DELETE_SECTION_FAILURE',
}

/*
 * Data types
 */
export interface SectionInterface {
  id: string;
  name: string;
  startId: string;
  endId: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  startStop?: StopInterface;
  endStop?: StopInterface;
}

/*
 * State type
 */
export interface SectionsState {
  readonly sectionsList: SectionInterface[];
  readonly sectionData: SectionInterface;
  readonly sectionCreated: SectionInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
